<header id="countDown" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" [ngClass]="{'red': totalSeconds <= remindSeconds, 'gray': false}">
  倒计时&nbsp;&nbsp;<span id="timer_m"></span>:<span id="timer_s"></span>
</header>


// WEBPACK FOOTER //
// ./src/app/countdown/countdown.component.html